import React from 'react';
import { Button } from 'react-bootstrap';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import CommonStrings from 'resources/common-strings';
import HelpBox from 'components/generic/help/index';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';

import GradeDropdown from './grade-dropdown';

export default CreateReactClass({
    displayName: 'LearningStatementsFilters',
    mixins: [DeepCompareComponentShouldUpdateMixin],

    propTypes: {
        groupBy: PropTypes.string,
        hideLearningStatements: PropTypes.bool,
        onGroupByChange: PropTypes.func,
        handleShowHideLCChange: PropTypes.func,
        handleStrengthFilter: PropTypes.func,
        grades: PropTypes.instanceOf(Immutable.List),
        selectedGrades: PropTypes.instanceOf(Immutable.Set),
        onDropdownHide: PropTypes.func.isRequired,
        strengthFilter: PropTypes.instanceOf(Immutable.Set),
        currentTestEvent: PropTypes.instanceOf(Immutable.Map),
        standardTypes: PropTypes.instanceOf(Immutable.List),
    },

    handleGroupByChange(value) {
        this.props.onGroupByChange(value);
    },
    handleStrengthFilterChange(e) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.instructionalAreas, 'change-view', e.target.id);
        this.props.handleStrengthFilter(e);
    },
    onDropdownHide(selectedGrades) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.instructionalAreas, 'change-grade');
        this.props.onDropdownHide(selectedGrades);
    },
    handleShowHideLCChange(showHideFlag) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.instructionalAreas, 'change-view-learning-continuum');
        this.props.handleShowHideLCChange(showHideFlag);
    },

    learningStatementsToFilter() {
        return (
            <div className="learning-statements-to-view-filter">
                <span className="filter-label screen-only" htmlFor="group-by-btn-group-1">
                    View learning statements to :
                    <HelpBox
                        id={'instructional-areas-strength-filter-help-box-header'}
                        className="strength-help"
                        helpContentsRenderer={this.helpText}
                        moduleName={CommonValues.SectionIDs.instructionalAreas}
                        appLevelCssClassName="instructional-areas-learning-statements-help"
                        helpLabel="instructional-areas-strength-filter-help"
                    />
                </span>
                <span className="filter-label print-only">Concepts to :&nbsp;</span>
                <input
                    type="checkbox"
                    id="reinforce"
                    checked={this.props.strengthFilter.includes('reinforce')}
                    onChange={this.handleStrengthFilterChange}
                    className={this.props.strengthFilter.includes('reinforce') ? 'checkbox-checked' : 'checkbox-inline'}
                    name="filter-statements"
                />
                <label className="strength-label">Reinforce</label>
                <input
                    type="checkbox"
                    id="develop"
                    checked={this.props.strengthFilter.includes('develop')}
                    className={this.props.strengthFilter.includes('develop') ? 'checkbox-checked' : 'checkbox-inline'}
                    onChange={this.handleStrengthFilterChange}
                    name="filter-statements"
                />
                <label className="strength-label">Develop</label>
                <input
                    type="checkbox"
                    id="introduce"
                    checked={this.props.strengthFilter.includes('introduce')}
                    className={this.props.strengthFilter.includes('introduce') ? 'checkbox-checked' : 'checkbox-inline'}
                    onChange={this.handleStrengthFilterChange}
                />
                <label className="strength-label">Introduce</label>
            </div>
        );
    },

    helpText() {
        return (
            <div key="ia-expanded-filter-help-content">
                <p key="filter-help-main-header" className="filter-help-main-header">
                    {CommonStrings.instructionalAreasFilterHelp.mainHeader}
                </p>
                <p key="initial-text" className="filter-text">
                    {CommonStrings.instructionalAreasFilterHelp.initialText}
                </p>
                <p key="reinforce-head" className="filter-head">
                    {CommonStrings.instructionalAreasFilterHelp.reinforceHead}
                </p>
                <p key="reinforce-text" className="filter-text">
                    {CommonStrings.instructionalAreasFilterHelp.reinforceText}
                </p>
                <p key="develop-head" className="filter-head">
                    {CommonStrings.instructionalAreasFilterHelp.developHead}
                </p>
                <p key="develop-text" className="filter-text">
                    {CommonStrings.instructionalAreasFilterHelp.developText}
                </p>
                <p key="introduce-head" className="filter-head">
                    {CommonStrings.instructionalAreasFilterHelp.introduceHead}
                </p>
                <p key="introduce-text" className="filter-text">
                    {CommonStrings.instructionalAreasFilterHelp.introduceText}
                </p>
                <p key="footer-text" className="filter-text">
                    {CommonStrings.instructionalAreasFilterHelp.mainFooter.openingText}
                    <span className="underline">
                        {CommonStrings.instructionalAreasFilterHelp.mainFooter.underlinedText}
                    </span>
                    {CommonStrings.instructionalAreasFilterHelp.mainFooter.closingText}
                </p>
                <div key="help-link-section">
                    <strong key="read-more">{CommonStrings.instructionalAreasFilterHelp.readMoreText}</strong>
                    <a key="help-link" href={CommonStrings.instructionalAreasFilterHelp.helpLink} target="_blank">
                        {CommonStrings.instructionalAreasFilterHelp.helpLinkText}
                    </a>
                </div>
            </div>
        );
    },

    render() {
        const descartes =
            this.props.groupBy === CommonValues.StandardTypes.descartes.storeValue ? (
                <span className="print-only">&nbsp; Descartes</span>
            ) : (
                ''
            );

        return (
            <div className="form-group" key="learning-statement-filters">
                <div
                    className={
                        this.props.groupBy === CommonValues.StandardTypes.descartes.storeValue
                            ? 'cursor-disabled group-by-filter'
                            : 'cursor-normal group-by-filter'
                    }
                >
                    <span className="filter-label" htmlFor="group-by-btn-group">
                        Group by :
                    </span>
                    <Button
                        key="btn-standard"
                        id={`btn-standard`}
                        onClick={(e) => {
                            this.handleGroupByChange(CommonValues.StandardTypes.standard.storeValue);
                            Analytics.recordButtonClick(
                                CommonValues.SectionIDs.instructionalAreas,
                                'change-grouping',
                                CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD
                            );
                        }}
                        active={this.props.groupBy === CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD}
                        disabled={!this.props.standardTypes.contains(CommonValues.StandardTypes.standard.storeValue)}
                        className="filter-grp-btn"
                    >
                        Standard
                    </Button>
                    <Button
                        key="btn-topic"
                        id={`btn-topic`}
                        onClick={(e) => {
                            this.handleGroupByChange(CommonValues.StandardTypes.topic.storeValue);
                            Analytics.recordButtonClick(
                                CommonValues.SectionIDs.instructionalAreas,
                                'change-grouping',
                                CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC
                            );
                        }}
                        active={this.props.groupBy === CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC}
                        disabled={!this.props.standardTypes.contains(CommonValues.StandardTypes.topic.storeValue)}
                        className="filter-grp-btn"
                    >
                        Topic
                    </Button>
                    {descartes}
                </div>
                <div
                    className={
                        this.props.groupBy === CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC
                            ? 'grades-filter screen-only'
                            : 'grades-filter'
                    }
                >
                    <span className="filter-label" htmlFor="group-by-btn-group">
                        Grade(s) :
                    </span>
                    <GradeDropdown
                        grades={this.props.grades}
                        selectedGrades={this.props.selectedGrades}
                        onDropdownHide={this.onDropdownHide}
                        disabled={this.props.groupBy != CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD ? true : false}
                    />
                </div>
                <div className="learning-statements-filter">
                    <span className="filter-label" htmlFor="group-by-btn-group-1">
                        Show learning statements :
                    </span>
                    <Button
                        key="btn-show"
                        id={`btn-show`}
                        onClick={(e) => this.handleShowHideLCChange(false)}
                        active={!this.props.hideLearningStatements}
                        className="filter-grp-btn"
                    >
                        SHOW
                    </Button>
                    <Button
                        key="btn-hide"
                        id={`btn-hide`}
                        onClick={(e) => this.handleShowHideLCChange(true)}
                        active={this.props.hideLearningStatements}
                        className="filter-grp-btn"
                    >
                        HIDE
                    </Button>
                </div>
                {this.learningStatementsToFilter()}
            </div>
        );
    },
});
